import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { profilePopoverCSS } from './ProfilePopover.css';

const ROLE_LABELS = {
    '1': 'Admin Pei',
    '2': 'Vendedor Pei',
    '3': 'Admin Trim',
    '4': 'Vendedor Trim',
};

const getInitials = (name = '') =>
    name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase())
        .join('') || '?';

const ProfilePopover = ({ open, onClose, user, onGoDashboard, onLogout }) => {
    const panelRef = useRef(null);

    useEffect(() => {
        if (!open) return;
        const handleKey = (e) => { if (e.key === 'Escape') onClose?.(); };
        document.addEventListener('keydown', handleKey);
        return () => document.removeEventListener('keydown', handleKey);
    }, [open, onClose]);

    const role = ROLE_LABELS[String(user?.type_user ?? '')];

    return (
        <AnimatePresence>
            {open && (
                <>
                    <motion.div
                        css={profilePopoverCSS()}
                        className="pp-backdrop"
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        transition={{ duration: 0.15 }}
                        onClick={onClose}
                    />
                    <motion.div
                        ref={panelRef}
                        css={profilePopoverCSS()}
                        className="pp-panel"
                        initial={{ opacity: 0, y: -8, scale: 0.97 }}
                        animate={{ opacity: 1, y: 0, scale: 1 }}
                        exit={{ opacity: 0, y: -8, scale: 0.97 }}
                        transition={{ type: 'spring', stiffness: 400, damping: 28 }}
                        role="menu"
                    >
                        <div className="pp-header">
                            <h3 className="pp-title">Mi cuenta</h3>
                        </div>

                        <div className="pp-list">
                            <div className="pp-item active">
                                <div className="pp-avatar">{getInitials(user?.name)}</div>
                                <div className="pp-item-text">
                                    <div className="pp-item-row">
                                        <span className="pp-item-name">{user?.name || 'Sin nombre'}</span>
                                        <span className="pp-active-badge">Activo</span>
                                    </div>
                                    <span className="pp-item-sub">{user?.email || '—'}</span>
                                    {role && <span className="pp-role-chip">{role}</span>}
                                </div>
                            </div>

                            <div className="pp-divider" />
                            <p className="pp-section-label">Acciones</p>

                            <button
                                type="button"
                                className="pp-item clickable"
                                onClick={() => { onClose?.(); onGoDashboard?.(); }}
                                role="menuitem"
                            >
                                <div className="pp-icon"><i className="pi pi-th-large" /></div>
                                <div className="pp-item-text">
                                    <span className="pp-item-name">Mi panel</span>
                                    <span className="pp-item-sub">Volver a tu dashboard</span>
                                </div>
                                <i className="pi pi-chevron-right pp-chevron" />
                            </button>

                            <button
                                type="button"
                                className="pp-item clickable danger"
                                onClick={() => { onClose?.(); onLogout?.(); }}
                                role="menuitem"
                            >
                                <div className="pp-icon danger"><i className="pi pi-sign-out" /></div>
                                <div className="pp-item-text">
                                    <span className="pp-item-name">Cerrar sesión</span>
                                    <span className="pp-item-sub">Salir de tu cuenta</span>
                                </div>
                                <i className="pi pi-chevron-right pp-chevron" />
                            </button>
                        </div>
                    </motion.div>
                </>
            )}
        </AnimatePresence>
    );
};

export default ProfilePopover;
